import React from "react";
import img1 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
import { MdKeyboardArrowRight } from "react-icons/md";
import img2 from "../../../../../../assets/images/AISummit/aicopilot1.jpg";
import img3 from "../../../../../../assets/images/AISummit/aicopilot1.jpg";


const OfferSection = () => {

    const EventCards = [
        {
            id: 1,
            img: img1,
            subheading: "Support",
            heading: "Full event management from start to finish",
            desc: "Planning, promotion, execution, and follow-up handled completely",
            button: "Learn"

        },
        {
            id: 2,
            img: img2,
            subheading: "Access",
            heading: "Industry mentors and exclusive learning resources",
            desc: "Connect your students with professionals who shape the tech world",
            button: "Explore"

        },
        {
            id: 3,
            subheading: "Proven",
            img: img3,
            heading: "Five years of community building experience",
            desc: "Over 100 events hosted with thousands of engaged participants",
            button: "Discover"

        },
    ];
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-10 text-center">
                        <h6 className="fs-14">What we offer</h6>
                        <h1>Events shaped your way</h1>
                        <p>Workshops, hackathons, master classes, or casual meetups</p>
                    </div>
                    <div className="row mx-0 d-flex align-items-center justify-content-center py-5">
                        {EventCards.map((item, id) => (
                            <div className="col-12 col-md-4" key={id}>
                                <div className="border radius-10 p-3 eventscard">
                                    <img className="img-fluid mb-3" src={item.img} alt="" />
                                    <h6 className="fs-14">{item.subheading}</h6>
                                    <h4 className="fs-24">{item.heading}</h4>
                                    <p>{item.desc}</p>
                                    <a>{item.button}<MdKeyboardArrowRight /></a>
                                </div>
                            </div>

                        )
                        )
                        }
                    </div>

                </div>
            </div>
        </section >
    );
};

export default OfferSection;
